<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">
      <img src="assets/images/logo-white.png" alt="TVSHelper Logo" class="header-logo">
    </a>
  </div>
</div>

<div class="header-container">
  <div
    class="notification-wrapper"
    [nbPopover]="notificationList"
    nbPopoverPlacement="bottom"
    nbPopoverTrigger="click"
  >
    <nb-icon icon="bell-outline" size="large"></nb-icon>
    <nb-badge
      [text]="unreadNotificationsCount > 9 ? '9+' : unreadNotificationsCount"
      [status]="unreadNotificationsCount > 0 ? 'danger' : 'success'"
      position="top right"
    >
    </nb-badge>
  </div>

  <ng-template #notificationList>
    <nb-card size="medium" class="notification-list-card">
      <nb-card-body>
        <div class="notification-list-header">
          <div class="notification-title-group">
            <span class="notification-list-title">Notifications</span>
            <span class="notification-title-count" *ngIf="unreadNotificationsCount > 0">{{
              unreadNotificationsCount
            }}</span>
          </div>
          <span
            *ngIf="unreadNotificationsCount > 0"
            class="notification-mark-all"
            (click)="markAllRead()"
            title="Mark all as read"
          >
            <nb-icon icon="done-all-outline"></nb-icon> Mark all read
          </span>
        </div>
        <div class="notification-tabs">
          <span
            class="notification-tab"
            [class.notification-tab--active]="notificationFilter === 'all'"
            (click)="setFilter('all')"
          >All</span>
          <span
            class="notification-tab"
            [class.notification-tab--active]="notificationFilter === 'unread'"
            (click)="setFilter('unread')"
          >Unread<span class="notification-tab-count" *ngIf="unreadNotificationsCount > 0">{{
            unreadNotificationsCount
          }}</span></span>
          <span
            class="notification-tab"
            [class.notification-tab--active]="notificationFilter === 'tasks'"
            (click)="setFilter('tasks')"
          >Tasks</span>
          <span
            class="notification-tab"
            [class.notification-tab--active]="notificationFilter === 'payments'"
            (click)="setFilter('payments')"
          >Payments</span>
        </div>
        <div class="notification-list-scroll" (scroll)="onNotificationListScroll($event)">
          <div *ngIf="filteredNotifications.length; else noNotifications">
            <div
              *ngFor="let notification of filteredNotifications"
              class="notification-item"
              [class.notification-item--read]="isNotificationRead(notification)"
              [class.notification-item--unread]="!isNotificationRead(notification)"
              [class.notification-item--clickable]="getNotificationLink(notification)"
              (click)="onNotificationClick(notification)"
              [title]="
                getNotificationLink(notification) ? 'Click to open' : 'Click to mark as read'
              "
            >
              <div class="notification-icon">
                <nb-icon
                  [icon]="notificationMeta(notification.event).icon"
                  [status]="notificationMeta(notification.event).status"
                ></nb-icon>
              </div>
              <div class="notification-body">
                <div class="notification-header">
                  <strong>{{ notification.title }}</strong>
                  <small [title]="notification.createdAt | date : 'd MMM y, h:mm a'">{{
                    timeAgo(notification.createdAt)
                  }}</small>
                </div>
                <div class="notification-content">
                  {{ notification.content }}
                </div>
              </div>
              <span class="notification-dot" *ngIf="!isNotificationRead(notification)"></span>
            </div>
            <div *ngIf="loadingNotifications && notifications.length" class="notification-loading">
              <nb-spinner size="small" status="primary"></nb-spinner>
            </div>
          </div>
          <ng-template #noNotifications>
            <div class="notification-empty">
              <nb-icon icon="bell-off-outline"></nb-icon>
              <p>{{ notificationFilter === 'all' ? "You're all caught up" : 'Nothing here' }}</p>
            </div>
          </ng-template>
        </div>
      </nb-card-body>
    </nb-card>
  </ng-template>

  <nb-actions size="small">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user
        [nbContextMenu]="userMenu"
        nbContextMenuTag="user-menu"
        [onlyPicture]="userPictureOnly"
        [name]="user?.firstName"
        [picture]="user?.avatar?.path || 'assets/images/user.png'"
      >
      </nb-user>
      <small style="color:rgba(255,255,255,0.4); font-size:10px; margin-left:4px; cursor:pointer;"
        title="Click your name to change mode">
        {{ isDarkMode ? '☀️' : '🌙' }}
      </small>
    </nb-action>
  </nb-actions>
</div>
